import { Locale, type Localized } from "../Locale.js";
import type { Product } from "../Product.js";

const defaultHeadingMap: Localized<(name: string) => string> = {
	[Locale.cs]: (name) => `Komu ${name} nejčastěji pomáhá`,
};

export function getProductBenefitsHeading(product: Pick<Product, "name" | "benefitsHeading" | "locale">): string {
	return product.benefitsHeading ?? defaultHeadingMap[product.locale](product.name);
}
